export const formatNumber = (value, decimals = 0) => {
  const num = Number(value);
  if (Number.isNaN(num)) return "—";
  return num.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatCurrency = (value, currency = "Rs.") => {
  const amount = formatNumber(value);
  return `${currency} ${amount}`;
};

export const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatKm = (value) => `${formatNumber(value)} km`;

const LIST_GETTERS = {
  pendingInvoices: (data) => data.list,
  pendingDeliveryNotes: (data) => data.list,
  savingsByVehicle: (data) => data.list,
  marketPriceVsSpent: (data) => data.list,
};

export const isComingSoon = (data) => Boolean(data?.comingSoon);

export const isEmptyResult = (questionId, data) => {
  if (data == null) return true;
  if (data.comingSoon) return false;
  if (questionId === "totalVehicles" || questionId === "mileageSummary") {
    return !Array.isArray(data.vehicles) || data.vehicles.length === 0;
  }
  if (questionId === "servedVehicles") {
    const throughput = data.throughput || {};
    return !(
      Number(throughput.totalServedVehicles) ||
      Number(throughput.totalDeliveryNotesCount) ||
      Number(throughput.totalVehicles)
    );
  }
  if (questionId === "servicesThisMonth") {
    const month = data.month || {};
    const upcoming = Number(month.upcoming?.vehiclesAffected) || 0;
    const due = Number(month.aiPmsDue?.vehicles) || 0;
    const schedule = Number(month.aiPmsSchedule?.vehicles) || 0;
    return upcoming + due + schedule === 0;
  }
  if (questionId === "upcomingServices") {
    const upcoming = Number(data.upcoming?.vehiclesAffected) || 0;
    const schedule = Number(data.aiPmsSchedule?.vehicles) || 0;
    return upcoming + schedule === 0;
  }
  if (questionId === "overdueServices") {
    return !(Number(data.aiPmsDue?.vehicles) || 0);
  }
  if (questionId === "serviceHistory") {
    return !Array.isArray(data.list) || data.list.length === 0;
  }
  if (questionId === "invoicesCurrentMonth") {
    return !(data.summary?.currentMonth?.items || []).length;
  }
  if (questionId === "invoicesLastMonth") {
    return !(data.summary?.lastMonth?.items || []).length;
  }
  if (questionId === "invoiceSummary") {
    return !(Number(data.summary?.totalInvoices) || 0);
  }
  if (questionId === "dnCurrentMonth") {
    return !(data.summary?.currentMonth?.items || []).length;
  }
  if (questionId === "dnLastMonth") {
    return !(data.summary?.lastMonth?.items || []).length;
  }
  if (questionId === "deliveryNoteSummary") {
    return !(Number(data.summary?.totalDeliveryNotes) || 0);
  }
  if (questionId === "totalSavings") {
    return !(Number(data.summary?.totalDeliveryNotes) || 0);
  }
  if (questionId === "savingsThisMonth") {
    return !(data.monthly?.items || []).length;
  }
  const getter = LIST_GETTERS[questionId];
  if (getter) {
    const list = getter(data);
    return !Array.isArray(list) || list.length === 0;
  }
  return false;
};
